<template>
  <div class="app">
    <!-- class="app flex-row align-items-center"-->

    <b-row
      ><!-- class="justify-content-center" -->
      <b-col cols="12" col md="4">
        <b-card no-body>
          <b-card-body>
            <b-form>
              <h3>Registro de usuario</h3>
              <p class="text-muted">Crear cuenta</p>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-user"></i
                  ></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  :value="registerNombre"
                  @input="setRegisterNombre"
                  @keyup.enter="register"
                  placeholder="Nombre"
                  autocomplete="nombre"
                />
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>@</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  :value="registerEmail"
                  @input="setRegisterEmail"
                  class="form-control"
                  placeholder="Email"
                  autocomplete="email"
                />
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-user"></i
                  ></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  :value="registerUser"
                  @input="setRegisterUser"
                  @keyup.enter="register"
                  placeholder="Usuario"
                  autocomplete="username"
                />
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="password"
                  :value="registerPassword"
                  @input="setRegisterPassword"
                  @keyup.enter="register"
                  class="form-control"
                  placeholder="Contraseña"
                  autocomplete="new-password"
                />
              </b-input-group>
              <b-button variant="success" block @click="register"
                >Crear Cuenta</b-button
              >
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Register",
  computed: {
    ...mapState("authentication", [
      "registerNombre",
      "registerEmail",
      "registerUser",
      "registerPassword",
      "registerError"
    ])
  },
  methods: {
    ...mapMutations("authentication", [
      "setRegisterNombre",
      "setRegisterUser",
      "setRegisterPassword",
      "setRegisterEmail",
      "setRegisterError"
    ]),
    ...mapActions("authentication", ["register"])
  }
};
</script>
